<!-- App.svelte -->
<script>
  import { Router, Route } from "svelte-routing";

  import { api } from "./libs/api.js";

  import Index from "./pages/Index.svelte";
  import Login from "./pages/Login.svelte";
  import Start from "./pages/Start.svelte";
  import Course from "./pages/Course.svelte";


  export let url = "";

  let loaded = api.refresh_token();
</script>

{#await loaded}
  <!-- This branch and its logic could be removed in production -->
  <div class="hero min-h-screen bg-base-100">
    <div class="hero-content flex-col">
      <p>Loading . . . </p>
      <progress class="progress progress-primary w-56" value="100" max="100"></progress>
    </div>
  </div>
{:then proceed}

<Router url="{url}">
  <Route path="/course/:course_id" component="{Course}" />
  <Route path="/start" component="{Start}" />
  <Route path="/login" component="{Login}" />
  <Route path="/" component="{Index}" />
</Router>

{/await}
